var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 18.715V70c0 5.523-4.477 10-10 10H49.123c-11.731-5.47-16.867-17.202-17.581-28.366a26.138 26.138 0 01-.108-2.057c.027-.34.04-.68.055-1.029.013-.334.026-.674.053-1.028C32.516 32.288 41.72 16 64.677 16h.758c5.665 0 10.492.992 14.565 2.715z",
    fill: "#E9DC6C",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dOthers)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.164 29.257H27v38.135h35.164V29.257z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 65.125H30.849V26H67v39.125zm-35.163-.99h34.175V26.99H31.837v37.147z",
    fill: "#E9DC6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.238 48.287a2.476 2.476 0 100-4.953 2.476 2.476 0 000 4.953zm6.934 0a2.476 2.476 0 100-4.953 2.476 2.476 0 000 4.953zm6.929 0a2.476 2.476 0 100-4.953 2.476 2.476 0 000 4.953z",
    fill: "#E9DC6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dOthers",
    x: 21,
    y: 22,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.7977974a0d14095a379fcd33d473be2c.svg";
export { ForwardRef as ReactComponent };